/**
 * 小水力発電とはページに関する処理
 */

export default class SmallHydropower {
  constructor() {
    this.parent = document.querySelector('#js-page-small-hydropower');
    if (!this.parent) return;
    this.init();
  }

  /**
   * SPで[横スクロール or 全体表示]を切り替える図
   */
  spScrollFigureInit() {
    const figure = document.querySelector('#js-toggle-view-figure');
    const buttonScroll = document.querySelector('#js-toggle-view-button-scroll');
    const buttonFull = document.querySelector('#js-toggle-view-button-full');
    const figureScrollClass = 'is-scroll';
    const toggleCurrentClass = 'is-current';
    const toggle = (toggleButton) => {
      if (toggleButton.value === 'scroll') {
        figure.classList.add(figureScrollClass);
        buttonScroll.classList.add(toggleCurrentClass);
        buttonFull.classList.remove(toggleCurrentClass);
        return;
      }
      figure.classList.remove(figureScrollClass);
      buttonScroll.classList.remove(toggleCurrentClass);
      buttonFull.classList.add(toggleCurrentClass);
    }
    buttonScroll.addEventListener('click', (e) => {
      toggle(e.currentTarget);
    });
    buttonFull.addEventListener('click', (e) => {
      toggle(e.currentTarget);
    });
  }

  init() {
    this.spScrollFigureInit();
  }
}
